import * as React from 'react';

import { BreadcrumbsV2 as RDCBreadcrumbs } from '@uncinc/react-drupal-core';

import './style.scss';

const Breadcrumbs: React.FC = () => (
  <RDCBreadcrumbs
    showHomeIcon={false}
  />
);

export default Breadcrumbs;
